﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListMandant extends GuiListGeneric {
    constructor() {
        super("Mandant");

    }

}
